import clsx from 'clsx';
import React, { ComponentPropsWithoutRef } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './styles.module.css';

interface Props extends ComponentPropsWithoutRef<'button'> {
  variant: 'contained' | 'text' | 'outlined';
  color?: 'primary' | 'greenish' | 'secondary' | 'danger' | 'softBlue';
  size?: 'small' | 'medium' | 'large' | 'full';
  classNames?: string;
  onClick?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  iconLeft?: React.ReactElement;
  isLoading?: boolean;
}

export default function ActionButton({
  className,
  variant,
  color,
  size = 'small',
  children,
  onClick,
  disabled,
  iconLeft,
  isLoading = false,
  ...rest
}: Props) {
  const btnStyle = {
    // Variant
    [styles.contained]: variant === 'contained',
    [styles.outlined]: variant === 'outlined',
    [styles.text]: variant === 'text',
    // Color
    [styles.colorPrimary]: color === 'primary',
    [styles.colorGreenish]: color === 'greenish',
    [styles.colorSecondary]: color === 'secondary',
    [styles.colorDanger]: color === 'danger',
    [styles.colorSoftBlue]: color === 'softBlue',
    // Size
    [styles.small]: size === 'small',
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.fullWidth]: size === 'full',
    [styles.isLoading]: isLoading,
  };

  return (
    <button className={clsx(className, styles.base, btnStyle)} onClick={onClick} disabled={disabled} {...rest}>
      {isLoading ? (
        <CircularProgress size={20} thickness={4} className={styles.progress} />
      ) : (
        <>
          {iconLeft && <span className={styles.icon}>{iconLeft}</span>}
          {children}
        </>
      )}
    </button>
  );
}
